import { ShieldAlert } from 'lucide-react'
import { NO_ACCESS_MESSAGE } from '../../api/errors'

/**
 * Pannello standard per le sezioni vietate dai permessi (HTTP 403).
 * Da usare al posto dell'errore generico quando l'utente apre una pagina
 * o un tab che il suo ruolo non può vedere: spiega e indica a chi chiedere.
 */
export function NoAccess({ message = NO_ACCESS_MESSAGE }: { message?: string }) {
  return (
    <div
      className="mx-auto flex max-w-lg flex-col items-center gap-2 rounded-lg border border-dashed border-border bg-surface px-6 py-10 text-center"
      role="alert"
    >
      <ShieldAlert size={28} className="text-muted" aria-hidden />
      <p className="m-0 text-base font-semibold text-heading">Accesso non consentito</p>
      <p className="m-0 text-sm text-muted">{message}</p>
    </div>
  )
}
